// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PushpinOutlinedSvg from "@ant-design/icons-svg/es/asn/PushpinOutlined";
import AntdIcon from '../components/AntdIcon';

var PushpinOutlined = function PushpinOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PushpinOutlinedSvg
  }));
};

PushpinOutlined.displayName = 'PushpinOutlined';
export default React.forwardRef(PushpinOutlined);